import React, { memo } from 'react';
import AssetsPickerLocal from 'packages/pages/components/AssetsPickerModal/components/AssetsPickerLocal';
import useCompactView from 'packages/pages/components/useCompactView';
import { AssetGroup } from 'packages/pages/editor/ContentPickerModal/types';

type Props = {
    type: 'audio' | 'video' | 'image' | 'document' | 'all'[];
    collectionId: number | null;
    assetType: string;
    selectedItems: any[];
    onSelectLocal: (asset: any) => void;
    compactViewProps: any;
    isPersonalUploadsAllowed: boolean;
    filterTypes?: string[];
    uploadTypes?: 'audio' | 'video' | 'image' | 'document' | 'all'[];
};

const AssetsPicker = ({
    type,
    selectedItems,
    collectionId,
    assetType,
    onSelectLocal,
    compactViewProps,
    isPersonalUploadsAllowed,
    filterTypes = [],
    uploadTypes = [],
}: Props) => {
    const { renderCompactView } = useCompactView(compactViewProps, false);

    const renderLocalCompactView = () => (
        <AssetsPickerLocal
            // @ts-ignore
            type={type}
            collectionId={collectionId}
            selectedObject={selectedItems}
            handleSelectRow={onSelectLocal}
            filterTypes={filterTypes}
            uploadTypes={uploadTypes}
            isPersonalUploadsAllowed={isPersonalUploadsAllowed}
        />
    );

    return assetType === AssetGroup.LOCAL ? renderLocalCompactView() : renderCompactView();
};

export default memo(AssetsPicker);
